import { render, staticRenderFns } from "./NotificationEventParameters.vue?vue&type=template&id=1b75f928&scoped=true"
import script from "./NotificationEventParameters.vue?vue&type=script&lang=js"
export * from "./NotificationEventParameters.vue?vue&type=script&lang=js"
import style0 from "./NotificationEventParameters.vue?vue&type=style&index=0&id=1b75f928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b75f928",
  null
  
)

export default component.exports